import createActionTypes from './createActionTypes';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import { actionPrefixes } from './constants';

const createLifeomicActionTypes = <T extends ReadonlyArray<string>>(
  actionTypes: T,
  prefixes: string[] = [],
) => {
  return createActionTypes(actionTypes, [actionPrefixes.LIFEOMIC, ...prefixes]);
};

const createAsyncActionTypes = <T extends ReadonlyArray<string>>(
  actionTypes: T,
  prefixes: string[] = [],
) => {
  return createActionTypes(actionTypes, [
    actionPrefixes.LIFEOMIC,
    actionPrefixes.ASYNC,
    ...prefixes,
  ]);
};

export {
  createAsyncActionTypes,
  createLifeomicActionTypes as createActionTypes,
};
